import React, { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';
import { CONTACT } from '../mock';
import { trackCallClick } from '../lib/analytics';

export const FloatingCallButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <a
      href={CONTACT.phoneHref}
      onClick={() => trackCallClick('floating_button')}
      data-testid="floating-call-button"
      aria-label={`Call us at ${CONTACT.phone}`}
      className={`md:hidden fixed bottom-5 right-5 z-50 inline-flex items-center gap-2.5 rounded-full bg-[#3D5142] text-white pl-4 pr-5 py-3.5 shadow-[0_10px_30px_rgba(38,48,42,0.4)] active:scale-95 transition-all duration-300 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}
    >
      <span className="relative flex w-5 h-5 items-center justify-center">
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#C4715A] opacity-60 animate-ping" />
        <Phone className="relative w-4.5 h-4.5 w-[18px] h-[18px]" />
      </span>
      <span className="text-[15px] font-medium">Call us</span>
    </a>
  );
};

export default FloatingCallButton;
